<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class=" px-3" style="background: #232323;" dark>
                    <span style="text-align: justify;" v-html="philosophy.content" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import configService from '@/services/config'
    export default {
        data() {
            return {
                philosophy: null
            }
        },
        created() {
            this.getPhilosophy()
        },
        methods: {
            getPhilosophy() {
                configService.getConfigField('philosophy').then(resp => {
                    this.philosophy = resp.data
                })
            }
        }
    }
</script>
